/**
 * SimpleModeEditor — pure layout shell for simple mode.
 *
 * 4-panel grid (all collapsible):
 *   [Edition 340px] | [Preview flex] | [MiseEnPage 260px] | [ActionRail 80px]
 *
 * Receives already-constructed panels as render slots to avoid prop drilling.
 */

interface SimpleModeEditorProps {
  leftRail: React.ReactNode;
  preview: React.ReactNode;
  atsPanel: React.ReactNode;
  miseEnPagePanel: React.ReactNode;
  actionRail: React.ReactNode;
  isSidebarOpen: boolean;
}

export function SimpleModeEditor({
  leftRail,
  preview,
  atsPanel,
  miseEnPagePanel,
  actionRail,
  isSidebarOpen,
}: SimpleModeEditorProps) {
  return (
    <div className="flex-1 min-h-0 flex flex-row overflow-hidden">
      {/* Left editing rail — collapsible */}
      <div
        className={`shrink-0 overflow-hidden flex flex-col border-r border-white/10 transition-all duration-300 ease-in-out ${
          isSidebarOpen ? 'w-[340px]' : 'w-0'
        }`}
      >
        <div className="flex-1 min-h-0 overflow-y-auto scrollbar-hide">
          {leftRail}
        </div>
      </div>

      {/* Preview — dominant center */}
      <div className="flex-1 min-w-0 overflow-hidden flex flex-col">
        {preview}
      </div>

      {/* ATS optimisation panel — collapsible from right */}
      {atsPanel}

      {/* Mise en page panel — collapsible from right */}
      {miseEnPagePanel}

      {/* Action rail — comfortable width, scrollable */}
      <div className="w-20 shrink-0 overflow-hidden flex flex-col">
        {actionRail}
      </div>
    </div>
  );
}
